import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INDRAApiService } from './api.indra.service';
import { 
	URL_VALIDATE_PROMO_CODE, 
	URL_VALIDATE_VOUCHER, 
	URL_PARTIAL_VOUCHER,
	MOCK_URL_VOUCHER_OK, 
	MOCK_STATUS, 
	MOCK_URL_VOUCHER_ERROR, 
	MOCK_URL_VOUCHER_NOT_FOUND, 
	MOCK_URL_PROMOCODE_OK, 
	URL_VOUCHER_IN_SESSION, 
	URL_PROMOCODE_IN_SESSION, 
	URL_REMOVE_PROMOCODE_IN_SESSION, 
	URL_REMOVE_VOUCHER_IN_SESSION,
	DISCOUNT_TYPE_VOUCHER,
	DISCOUNT_TYPE_PROMOCODE,
	MOCK_URL_VALIDATE_VOUCHER_CODE_OK,
	MOCK_URL_VALIDATE_VOUCHER_CODE_NOK,
	URL_VALIDATE_VOUCHER_CODE
} from '@ibe.config';

@Injectable({
	providedIn: 'root'
})
export class INDRADiscountService {

	constructor(private http: HttpClient, private api: INDRAApiService) {
	}

	validateVoucherPromoCode(code, type, bookAwards?) {	
		if (MOCK_STATUS.PROMOCODE_VOUCHER) {
				// return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_OK);
				// return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_ERROR);
				// return this.api.INDRA_get<any>(MOCK_URL_VOUCHER_NOT_FOUND);
				return this.api.INDRA_get<any>(MOCK_URL_PROMOCODE_OK);
		} else {
			if (type === DISCOUNT_TYPE_VOUCHER) {
				return this.api.INDRA_post<any>(URL_VALIDATE_VOUCHER, code);
			} else if (type === DISCOUNT_TYPE_PROMOCODE) {
				const params = {
					'payWithMiles': bookAwards,
					'promocode': code
				};
				
				return this.api.INDRA_post<any>(`${URL_VALIDATE_PROMO_CODE}`, params);
			}
		}
	}

	INDRA_validateVoucherPin(voucher: string, email: string, mfaCode: string) {
		if (MOCK_STATUS.VOUCHER_CODE) {
			// return this.api.INDRA_get<any>(MOCK_URL_VALIDATE_VOUCHER_CODE_NOK);
			return this.api.INDRA_get<any>(MOCK_URL_VALIDATE_VOUCHER_CODE_OK);
		} else {
			const params = {
				'voucher': voucher,
				'email': email,
				'mfaCode': mfaCode
			}

			return this.api.INDRA_post<any>(URL_VALIDATE_VOUCHER_CODE, params);
		}
	}

	INDRA_getVouchersInSession() {
		return this.api.INDRA_get<any>(`${URL_VOUCHER_IN_SESSION}`);
	}

	INDRA_getPromocodesInSession() {
		return this.api.INDRA_get<any>(`${URL_PROMOCODE_IN_SESSION}`);
	}

	INDRA_removePromoCodeInSession(code) {
		return this.api.INDRA_get<any>(`${URL_REMOVE_PROMOCODE_IN_SESSION}/${code}`);
	}

	INDRA_removeVoucherInSession(code) {
		return this.api.INDRA_get<any>(`${URL_REMOVE_VOUCHER_IN_SESSION}/${code}`);
	}

	INDRA_sendVoucherAmount(amount) {	
		return this.api.INDRA_post<any>(`${URL_PARTIAL_VOUCHER}`, amount);
	}
	

}

